// import React, { useState } from "react";
// import { Link } from "gatsby";
// import { Link as ScrollLink } from "react-scroll";

// const NavLinks = ({ linkClass }) => {
//   const [dropdownStatus, setDropdownStatus] = useState(false);
//   const handleDropdownStatus = () => {
//     setDropdownStatus(!dropdownStatus);
//   };
//   return (
//     <ul className="main-nav__navigation-box">
//       <li>
//         <Link to="/">Trang chủ</Link>
//       </li>
//       <li>
//         <ScrollLink
//         className={linkClass}
//           activeClass="current"
//           to="gioithieu"
//           spy={true}
//           smooth={true}
//           offset={-70}
//           duration={500}
//         >
//           Giới thiệu
//         </ScrollLink>
//       </li>
//       <li>
//         <ScrollLink
//         className={linkClass}
//           activeClass="current"
//           to="features"
//           spy={true}
//           smooth={true}
//           offset={-70}
//           duration={500}
//         >
//           Hướng dẫn
//         </ScrollLink>
//       </li>
//       <li>
//         <ScrollLink
//         className={linkClass}
//           activeClass="current"
//           to="pricing"
//           spy={true}
//           smooth={true}
//           offset={-70}
//           duration={500}
//         >
//           Gói phí
//         </ScrollLink>
//       </li>
//       {/* <li>
//         <ScrollLink
//           activeClass="current"
//           to="team"
//           spy={true}
//           smooth={true}
//           offset={-70}
//           duration={500}
//         >
//           Team
//         </ScrollLink>
//       </li> */}
//       {/* <li>
//         <ScrollLink
//         className={linkClass}
//           activeClass="current"
//           to="screens"
//           spy={true}
//           smooth={true}
//           offset={-70}
//           duration={500}
//         >
//           Hình ảnh
//         </ScrollLink>
//       </li> */}
//       {/* <li className="dropdown">
//         <Link to="/blog">Tin tức</Link>
//         <i
//           className="fa fa-angle-down"
//           onKeyDown={handleDropdownStatus}
//           role="button"
//           tabIndex="0"
//           aria-label="dropdown toggler"
//           onClick={handleDropdownStatus}
//         ></i>
//         <ul className={dropdownStatus === true ? "active" : null}>
//           <li>
//             <Link to="/blog">News</Link>
//           </li>
//           <li>
//             <Link to="/blog-post">News Details</Link>
//           </li>
//         </ul>
//       </li> */}
      
//     </ul>
//   );
// };

// export default NavLinks;


import React, { useState } from "react";
import { Link } from "gatsby";
import { Link as ScrollLink } from "react-scroll";
import { Modal, Button } from "react-bootstrap"; // Import modal từ react-bootstrap

const NavLinks = ({ linkClass, onLinkClick }) => {
  const [show, setShow] = useState(false); // State để điều khiển modal

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleMenuClick = (e, isModal = false) => {
    if (onLinkClick) {
      onLinkClick();
    }
    if (isModal) {
      e.preventDefault();
      handleShow();
    }
  };

  return (
    <>
      <ul className="main-nav__navigation-box">
        <li>
          <Link to="/" className={linkClass} onClick={(e) => handleMenuClick(e, false)}>Trang chủ</Link>
        </li>
        <li>
          <ScrollLink
            className={linkClass}
            activeClass="current"
            to="gioithieu"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={(e) => handleMenuClick(e, false)}
          >
            Giới thiệu
          </ScrollLink>
        </li>
        <li>
          {/* Thay vì dùng ScrollLink, bạn dùng button để mở modal */}
          {/* <Button variant="link" className={linkClass} onClick={handleShow}>
            Hướng dẫn
          </Button> */}
          <a href="#none" className={linkClass} onClick={(e) => handleMenuClick(e, true)} onKeyDown={(e) => { if(e.key === 'Enter') { handleMenuClick(e, true); } }} role="button" tabIndex={0}>
            Hướng dẫn
          </a>
        </li>
        <li>
          <ScrollLink
            className={linkClass}
            activeClass="current"
            to="pricing"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={(e) => handleMenuClick(e, false)}
          >
            Gói phí
          </ScrollLink>
        </li>
      </ul>

      {/* Modal sử dụng react-bootstrap */}
      <Modal className="modal-custom" show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Hướng dẫn</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '600px', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <img src="https://noi.dating/attachments/iudigt-jpg.13703/" alt="IUDIGT.jpg" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '80%', margin: '0 auto', display: 'block' }} />
        </div>
        <h4><strong>PHẦN 1</strong></h4>
        <ul>
          <li>Giới thiệu tổng quan về app</li>
          <li>Cách thức hoạt động</li>
          <li>Hướng dẫn sử dụng</li>
        </ul>
        
        <h4><strong>PHẦN 2</strong></h4>
        <ul>
          <li>Cách ghim ứng dụng/thêm ứng dụng IUDI vào màn hình chính điện thoại</li>
        </ul>
        
        <hr style={{ margin: '20px 0' }} />
        
        <h3 style={{ textAlign: 'center', color: 'rgb(166, 0, 255)' }}><u><strong>CHI TIẾT PHẦN 1</strong></u></h3>
        
        <h4 style={{ textAlign: 'center', color: 'rgb(255, 0, 102)' }}><strong>GIỚI THIỆU TỔNG QUAN</strong></h4>
        <p><strong>| IUDI - HÃY YÊU NHAU ĐI</strong></p>
        <p>
          Chào mừng bạn đến với <strong>IUDI</strong>, ứng dụng hẹn hò được tích hợp hoạt động trên nền tảng Zalo. Đây không chỉ là một app hẹn hò, mà là nơi kết nối những tâm hồn đồng điệu với sứ mệnh xây dựng mối quan hệ bền vững và ý nghĩa.
        </p>

        <h4 style={{ textAlign: 'center', color: 'rgb(247, 2, 100)' }}><strong>CÁCH THỨC HOẠT ĐỘNG</strong></h4>
        <ul>
          <li>Thành viên sẽ dùng <strong>Tài khoản/Nick Zalo cá nhân</strong> của mình, để đăng ký tạo hồ sơ hẹn hò</li>
          <li>Chờ BQT kiểm tra và xét duyệt hồ sơ, sau đó sẽ được kích hoạt tài khoản tham gia</li>
          <li>Phải chọn <strong>Đăng Ký Gói </strong> mới sử dụng được </li>
          <li>Tìm kiếm, lựa chọn, xem hồ sơ các đối tượng phù hợp. Nếu quan tâm, muốn kết nối với hồ sơ nào đó hãy bấm nút <strong>“LIKE”</strong> và chờ đợi đối phương phản hồi</li>
          <li>Sau đó, nếu đối phương cũng bấm <strong>"LIKE"</strong> ngược lại hồ sơ của bạn, thì cả 2 sẽ được chuyển qua mục <strong>"Quan tâm"</strong> nhau. Còn nếu đối phương bấm <strong>"DISLIKE"</strong> thì sẽ chuyển qua mục <strong>"Từ chối"</strong> hai bên không kết nối được với nhau</li>
          <li>Tại mục "<strong>Quan tâm" </strong> sẽ có 2 lựa chọn (<strong>CHAT ZALO</strong> hoặc <strong>HẸN GẶP</strong>). Nếu chọn CHAT ZALO thì hai bên sẽ được chuyển qua nhắn tin thẳng vào Nick Zalo cá nhân của nhau (nhưng chưa biết SĐT của nhau) và chức năng HẸN GẶP sẽ không thể sử dụng được nữa. Ngược lại, nếu chọn HẸN GẶP thi chức năng CHAT ZALO sẽ không thể sử dụng. Và lúc này cũng cần có sự <strong>XÁC NHẬN ĐỒNG Ý </strong> hẹn gặp từ cả hai bên, khi đó <strong>BQT trực tiếp</strong> đứng ra liên hệ riêng và sắp xếp một cuộc hẹn gặp cafe 1-1 cho cả hai (CÓ MẤT PHÍ DỊCH VỤ)</li>
          <li>Ngoài ra có thêm một số tình năng giúp tăng tương tác và tạo thêm cơ hội kết nối cho thành viên như: Ghép đôi hàng ngày, chơi game bẫy tìm, lên ghế vip 24h...</li>
        </ul>

        <h4 style={{ textAlign: 'center', color: 'rgb(255, 0, 102)' }}><strong>VÌ SAO NÊN CHỌN "IUDI"?</strong></h4>
        <p><strong>1. Bảo mật và an toàn tuyệt đối với nền tảng Zalo</strong></p>
        <ul>
          <li><strong>IUDI </strong> tận dụng <strong>sức mạnh bảo mật từ Zalo</strong>, giúp bạn đăng ký và tham gia với tài khoản Zalo cá nhân. Điều này không chỉ giúp bảo vệ quyền riêng tư của bạn mà còn giúp cập nhật các kết nối và tương tác một cách nhanh chóng, tiện lợi.</li>
          <li>Không có chức năng Chat/Nhắn tin trong app, mà chuyển qua nhắn tin Zalo. Điều này giúp tăng cường mức độ nghiêm túc, ý thức và trách nhiệm của thành viên với từng kết nối.</li>
        </ul>

        <p><strong>2. 100% thành viên thật - Tài khoản thật tại app</strong></p>
        <ul>
          <li>Chúng tôi <strong>CAM KẾT 100% thành viên thật</strong>. Mỗi người tham gia đều được xác thực và xác minh giấy tờ tùy thân, mang đến sự tin cậy trong từng kết nối. Không còn lo lắng về các tài khoản ảo hay thiếu trung thực.</li>
        </ul>

        <p><strong>3. Tính năng bảo mật đỉnh cao</strong></p>
        <ul>
          <li>Thông tin cá nhân riêng tư và số điện thoại của thành viên sẽ được <strong>bảo mật tuyệt đối</strong>. Những hình ảnh cá nhân chỉ hiển thị cho các thành viên đã được kích hoạt tài khoản và được kiểm duyệt bởi Ban Quản Trị.</li>
          <li>Bạn hoàn toàn kiểm soát được ai có quyền xem thông tin giới thiệu hồ sơ và hình ảnh của bạn.</li>
        </ul>

        <p><strong>4. Hỗ trợ 24/7</strong></p>
        <ul>
          <li>Đội ngũ nhân viên hỗ trợ online 24/7, giải đáp mọi thắc mắc và xử lý các vấn đề phát sinh một cách kịp thời. </li>
          <li>Bạn có thể yên tâm trải nghiệm và tìm kiếm tình yêu mà không phải lo lắng về bất kỳ vấn đề kỹ thuật nào.</li>
        </ul>

        <h4 style={{ textAlign: 'center', color: 'rgb(247, 2, 100)' }}><strong>MỘT CỘNG ĐỒNG: VĂN MINH - NGHIÊM TÚC - HIỆU QUẢ</strong></h4>
        <ul>
          <li><strong>Ứng dụng IUDI</strong> được điều hành bởi <strong>Nối Group</strong>, đơn vị đã có <strong>hơn 10 năm kinh nghiệm</strong> trong việc xây dựng cộng đồng kết nối độc thân văn minh và nghiêm túc tại Việt Nam. Với mong muốn mang lại một môi trường hẹn hò an toàn và hiệu quả, chúng tôi không ngừng nỗ lực xây dựng những tính năng hỗ trợ kết nối tốt nhất và đảm bảo sự minh bạch trong mọi tương tác.</li>
          <li>Tại <strong>IUDI,</strong> chúng tôi tin rằng <strong>ai cũng xứng đáng có được một tình yêu chân thực và mối quan hệ vững chắc</strong>. Đừng bỏ lỡ cơ hội trải nghiệm những cuộc trò chuyện chân thành và những buổi hẹn gặp đầy thú vị.</li>
        </ul>
        
        <p><em>Hãy để <strong>IUDI </strong> trở thành cầu nối giúp bạn tìm thấy tình yêu đích thực. </em></p>
        <p><strong>Tham gia ngay hôm nay!</strong></p>

        <h4 style={{ color: 'rgb(5, 53, 245)' }}><strong>VỀ CHÚNG TÔI</strong></h4>
        <p>
          <strong>CÔNG TY TNHH NỐI GROUP</strong><br />
          MST: 0318379051<br />
          Địa chỉ: Tòa Nhà Pearl Plaza, 561A Điện Biên Phủ, Phường Thạnh Mỹ Tây, TP.HCM<br />
          Điện thoại: <strong>0866.428.869</strong><br />
          Email: info.noidating@gmail.com<br />
          www.iudi.app | www.noi.dating
        </p>

        <hr style={{ margin: '20px 0' }} />

        <h4 style={{ textAlign: 'center', color: 'rgb(162, 2, 247)' }}><strong>CÁCH SỬ DỤNG VÀ TÍNH NĂNG NỔI BẬT</strong></h4>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777226676537.webp" alt="z5846169052814_9f91a8fe8fc6164346f76ef6870acf9a.jpg" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>

        <p>
          Mở Zalo trên điện thoại, nhập từ khóa <strong>“iudi”</strong> trên thanh tìm kiếm và chọn mục <strong>“Khám phá” </strong> sau đó nhấp vào kết quả mini app <strong>“IUDI - Ứng dụng hẹn hò” </strong> được hiển thị trên màn hình.
        </p>

        <h5 style={{ color: 'rgb(249, 1, 1)' }}><strong>Bảo mật hình ảnh 3 lớp</strong></h5>
        <ul>
          <li>Thành viên khi chưa đăng ký tài khoản (khách truy cập) khi vào app <strong>không thể xem</strong> được hình ảnh của các hồ sơ. </li>
          <li>Thành viên đã có tài khoản và đã được BQT xét duyệt chính thức tham gia app, sẽ chỉ xem được <strong>hình ảnh làm mờ</strong> của hồ sơ. </li>
          <li>Và chỉ khi cả 2 bên cùng bấm <strong>“LIKE”</strong> nhau, lúc đó mới xem được đầy đủ hình ảnh rõ nét.</li>
        </ul>

        <h5 style={{ color: 'rgb(249, 1, 1)' }}><strong>Công cụ tìm kiếm chuyên sâu và chính xác</strong></h5>
        <ul>
          <li>Tùy vào mỗi gói hồ sơ đăng ký sử dụng tại app, mà bạn sẽ nhận được các quyền lợi tìm kiếm theo các hạng mục tiêu chí riêng.</li>
          <li>Công cụ tìm kiếm giúp chọn lựa, sàng lọc nhóm đối tượng phù hợp theo mong muốn của bạn như: Tìm theo nơi ở, tìm theo quê quán, tìm theo tôn giáo, tìm theo nghề nghiệp…</li>
        </ul>

        <h5 style={{ color: 'rgb(250, 5, 5)' }}><strong>CHAT/Nhắn tin qua Zalo nhưng chưa biết số điện thoại</strong></h5>
        <ul>
          <li>Khi hai bên cùng bấm <strong>“LIKE”</strong> nhau thì có thể chọn kết nối CHAT qua Zalo cá nhân. Nhưng hoàn toàn chưa biết số điện thoại của nhau.</li>
          <li>Điều này giúp bạn chủ động kiểm soát các thông tin riêng tư của mình. Quyết định chia sẻ với ai và không chia sẻ với ai.</li>
        </ul>

        <h5 style={{ color: 'rgb(246, 4, 4)' }}><strong>Tính năng tự “Tự Ẩn hồ sơ” của bạn</strong></h5>
        <ul>
          <li>Tự ẩn hồ sơ của bạn <strong>không hiển thị công khai</strong> trên app, không ai có thể tìm kiếm hay xem được hồ sơ bạn. Nhưng bạn vẫn chủ động xem được hồ sơ, hình ảnh và kết nối bình thường với người khác. Khi bạn muốn kết nối với ai, thì người đó mới xem ngược lại được hồ sơ bạn.</li>
          <li>Giúp bạn chủ động quyết định ai được quyền xem hồ sơ hình ảnh của mình và ai không được xem.</li>
          <li>Hiện chức năng này chỉ áp dụng với <strong>GÓI VIP</strong> và <strong>GÓI SIÊU VIP</strong></li>
        </ul>

        <hr style={{ margin: '20px 0' }} />

        <h3 style={{ textAlign: 'center', color: 'rgb(166, 0, 255)' }}><u><strong>CHI TIẾT PHẦN 2</strong></u></h3>
        
        <p>
          Để thuận tiện cho các lần truy cập về sau một cách nhanh chóng, bạn hãy Ghim ứng dụng/thêm ứng dụng IUDI vào màn hình chính điện thoại của mình.
        </p>

        <h4>HƯỚNG DẪN CỤ THỂ VỚI ĐIỆN THOẠI: <strong>Android và IOS</strong></h4>
        
        <p><strong>Bước 1:</strong></p>
        <p>
          - Mở app IUDI lên và chọn menu có <strong>3 dấu chấm</strong> kích vào đó (hình minh họa)
        </p>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777227499012.webp" alt="HD.IUDIV42.jpg" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>

        <p><strong>Bước 2:</strong></p>
        <p>
          - Một bảng điều khiển menu chức năng sẽ hiện ra và bạn hãy chọn mục <strong>“Tạo phím tắt” </strong> để ghim app IUDI ra màn hình chính điện thoại của bạn.
        </p>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777227616378.webp" alt="HD.IUDIV41.jpg" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>

        <h4 style={{ color: 'rgb(255, 0, 0)' }}><strong>LƯU Ý CỤ THỂ</strong></h4>
        
        <h5 style={{ color: 'rgb(0, 51, 255)' }}><strong>1 - Với hệ điều hành IOS </strong></h5>
        <ul>
          <li>Điện thoại iphone/ipad của bạn phải đặt <strong>Safari là trình duyệt mặc định</strong></li>
          <li>Hoặc bạn có thể thao tác thủ công tự kích mở <strong style={{ color: 'rgb(2, 51, 247)' }}>trình duyệt Safari </strong> lên, sau đó nhập tên địa chỉ website này (hoặc <strong>copy/paste)</strong> vào trình duyệt Safari: <strong style={{ color: 'rgb(7, 164, 242)' }}>iudiapp.com</strong></li>
          <li>Làm theo video hướng dẫn để hoàn tất ghim ứng dụng ra màn hình chính điện thoại</li>
        </ul>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777228027585.webp" alt="henho4" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>

        <p>
          - Mọi người nên <span style={{ color: 'rgb(4, 52, 246)' }}>CHỈNH SỬA</span> LẠI TÊN <strong>“IUDI - Ứng dụng hẹn hò” </strong> thành tên <strong>“IUDI”</strong> hoặc <strong>"APP IUDI"</strong> để khi hiển thị trên màn hình điện thoại được đẹp hơn và đồng bộ với các ứng dụng khác.
        </p>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777228227142.webp" alt="henho5" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777228274559.webp" alt="henho6" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>

        <h5 style={{ color: 'rgb(5, 46, 250)' }}><strong>2 - Với hệ điều hành Android </strong></h5>
        <ul>
          <li>Đối với một số dòng máy, khi bạn bấm vào <strong>“Tạo phím tắt”</strong> sẽ tự động ghim app ra màn hình chính của điện thoại.</li>
          <li>Nhưng cũng có các dòng máy do tuỳ biến của một số hãng, ứng dụng Zalo cần được <strong>người dùng chủ động cấp quyền</strong> để có thể thêm <strong>Shortcut/ghim app</strong> ra màn hình chính.</li>
        </ul>
        <p>Các bước để chủ động cấp quyền bao gồm:</p>
        <ul>
          <li>Bước 1 - Nhấn giữ biểu tượng ứng dụng Zalo.</li>
          <li>Bước 2 - Từ menu popup, chọn App Info/Thông tin ứng dụng</li>
          <li>Bước 3 - Truy cập mục Quyền ứng dụng/Permissions/ -&gt; bật quyền Desktop shortcuts/Lối tắt màn hình chính</li>
        </ul>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777229170110.webp" alt="henho7" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777229179847.webp" alt="henho8" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777229184001.webp" alt="henho9" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>

        <p>
          <em><strong>(Lưu ý: </strong> Giao diện thiết lập cũng như các bước có thể khác nhau, tuỳ thuộc vào phiên bản Android tuỳ biến đang được sử dụng ở các dòng máy khác nhau)</em>
        </p>
        
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <img src="https://miniapp.iudi.app/uploads/news/1777223989856.webp" alt="V4.IUDI.jpg" style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px', width: '600px' }} />
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NavLinks;
